export enum OtpActionType {
  REGISTER = 'REGISTER',
  LINK_ACCOUNT = 'LINK_ACCOUNT',
  PI_MObile_Update = 'PI_MObile_Update',
  ThisIsMe = 'ThisIsMe',
  notMe = 'notMe'

}

export interface UserRegistration {
  companyId: string; // default: 'SAA'

  // 🔹 Personal Details
  firstName: string;
  lastName: string;
  dateOfBirth?: string | null; // nullable
  title: string;
  gender: string;
  placeOfResidence: string;
  nationality: string;

  // 🔹 Contact
  email: string;
  mobile: string;
  phoneExtension: string;

  // 🔹 Employment
  employeeCode: string;
  employeeType: string; // Travel Admin

  // 🔹 Identity
  idNumber: string;
  idType: string;
  passportNationality: string;
  expiryDate?: string | null; // nullable

  // 🔹 Security
  password: string;
  elmVerified: boolean;

  // 🔹 Consents
  consentTCPP: boolean;
  consentMarketingOffers: boolean;
  consentLinkAccount: boolean;

  // 🔹 System
  contactId: string;
  accountId: string;
  flag: string;
}

export interface OtpRequestPayload {
  type: 'email' | 'mobile';
  otpAction: 'mobileOrEmailValidation' | string;
  value: string;
  channel: 'email' | 'mobile';
  companyId: string;
  b2BId: string | null;
  b2BUserId: string | null;
  eventName: 'REGISTRATION' | string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
}

export interface EmailVerificationDialogData {
  data: TravelerFormData;
  Email: string;
  EmpType?: string;
  verifyMode: 'email' | 'sms';
  actionType: 'REGISTER' | 'LINK_ACCOUNT' | 'DocumentUpdate' | 'DocumentAdd';
  otpChecksum?: string;
  idType?: string;
  token?: string;
  sessionID?: string;
  elmStatus?: boolean;
  ConsentTCPP?: boolean;
  ConsentMarketing?: boolean;
  expiryDate?: string | Date;
}

export interface TravelerFormData {
  firstname: string;
  lastname: string;
  email: string;
  mobileNumber: string;
  countryCode: string;
  nationality: string;
  identityNumber: string;
  password?: string;
  userType?: string;
  residence?: string;
  gender?: string;
  title?: string;
  dateOfBirth?: string | Date;
  empCode?: string;
  subagentId?: string;
  saUserId?: string;
  userGuid?: string;

  /** Allow extra dynamic fields without TS error */
  [key: string]: any;
}
